<template>
  <div class="wrapper">
    <!-- <div class="topBox"></div> -->
    <p class="houseTitle">{{ postHouseInfo }}</p>
    <p class="prizeBox">
      <span class="ps1">总价</span>
      <span class="ps2">￥{{ formatMoney(houseData.houseSumFacePrice) }}</span>
    </p>
    <p class="prizeBox bp1">
      <span class="ps1">定金</span>
      <span class="ps2">￥{{ deposit2 }}</span>
    </p>
    <p class="houseBox " v-show="houseTypeNameFlag">
      <span class="hs1">户型</span>
      <span class="hs2">{{ houseData.houseTypeName }}</span>
    </p>
    <p class="houseBox" v-show="decorateNameFlag">
      <span class="hs1">装修类型</span>
      <span class="hs2">{{ houseData.decorateName }}</span>
    </p>
    <p class="houseBox" v-show="buildingAreaFlag">
      <span class="hs1">建筑面积</span>
      <span class="hs2">{{ houseData.planBuildArea }}㎡</span>
    </p>
    <p class="houseBox" v-show="insidebuildingAreaFlag">
      <span class="hs1">套内面积</span>
      <span class="hs2">{{ houseData.planSpaceArea }}㎡</span>
    </p>
    <p class="houseBox" v-show="buildingUnitPriceFlag">
      <span class="hs1">建筑单价</span>
      <span class="hs2">{{ houseData.houseFacePrice }}元/平方米</span>
    </p>
    <p class="houseBox" v-show="insideBuildingUnitPriceFlag">
      <span class="hs1">套内单价</span>
      <span class="hs2">{{ houseData.houseInsidePrice }}元/平方米</span>
    </p>
    <p class="saleBox sBox1">
      <span class="ss1">您的置业顾问</span>
      <span class="ss2">{{ saleName }}</span>
    </p>
    <p class="saleBox">
      <span class="ss1">联系电话</span>
      <span class="ss2">{{ saleMobile }}</span>
    </p>
    <!-- <div class="wranTitle">
      <p class="line"></p>
      <p class="wran">温馨提示</p>
      <p class="line"></p>
    </div> -->
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { MessageBox, Indicator } from "mint-ui";
import { mapState } from "vuex";
import request from "@/utils/request";
import wxsdk from "@/utils/wxsdk";
import Cookies from "js-cookie";
import "./components/all.css";
export default {
  data() {
    return {
      projectid: this.$route.query.pid ? this.$route.query.pid : 2343,
      houseData: "",
      buildingData: "",
      houseCode: this.$route.query.houseCode ? this.$route.query.houseCode : "",
      proSelectPeriodName: this.$route.query.proSelectPeriodName ? this.$route.query.proSelectPeriodName : "",
      prizeAll: 0,
      saleName: "",
      saleOpenid: "",
      saleMobile: "",
      saleImg: "",
      callFlag: false,
      hasUnitFlag: true,
      houseInfo: "",
      deposit: "",
      deposit2: "",
      postHouseInfo: "",
      shareProjectName: "",
      checkState: false,
      checkNum: 0,
      checkSpan: true,
      checkFlag: false,
      checkFlagUrl: "",
      houseTypeNameFlag: true,
      decorateNameFlag: true,
      buildingAreaFlag: true,
      insidebuildingAreaFlag: true,
      buildingUnitPriceFlag: true,
      insideBuildingUnitPriceFlag: true
    };
  },
  computed: {
    ...mapState([
      "isInMiniProgram",
      "pageInfo",
      "userInfo",
      "shareSpreadInfo",
      "receiveSpreadInfo",
      "rsCardInfo",
      "isShowGuide"
    ]),
    formatMoney() {
      return function(n) {
        return util.formatMoney(n)
      }
    }
  },
  watch: {},
  filters: {},
  methods: {
    // 获取个人信息
    getUserInfo() {
      let that = this;
      request
        .get(that.global.API_URL, {
          action: "/house/HouseOnlineAction/getUserInfo",
          requestParam: { projectId: that.projectid }
        })
        .then(function(data) {
          console.log(data.obj);
          that.saleOpenid = data.obj.salesperson;
          that.saleName = data.obj.spName;
          that.saleMobile = data.obj.spMobile;
          that.saleImg = data.obj.spHeadImgUrl;
        });
    },
    // 获取配置i信息
    getConfig() {
      let that = this;
      let deMoney = '';
      let showItem = "";
      request
        .get(that.global.API_URL, {
          action: "/house/HouseOnlineAction/getConfig",
          requestParam: { projectId: that.projectid }
        }).then(function(data) {
          console.log(data);
          if(data.obj.notShowFields != ""){
            showItem = data.obj.notShowFields.split(',')
          }
          console.log(showItem); 
          showItem.forEach(item => {
            if(item == "houseTypeName"){
              that.houseTypeNameFlag = false;
            }
            if(item == "decorateName"){
              that.decorateNameFlag = false;
            }
            if(item == "buildingArea"){
              that.buildingAreaFlag = false;
            }
            if(item == "insidebuildingArea"){
              that.insidebuildingAreaFlag = false;
            }
            if(item == "buildingUnitPrice"){
              that.buildingUnitPriceFlag = false;
            }
            if(item == "insideBuildingUnitPrice"){
              that.insideBuildingUnitPriceFlag = false;
            }
          })
          console.log(data.obj.deposit/100)
          that.deposit2 = data.obj.deposit / 100;
          that.shareProjectName = data.obj.name;
          that.checkFlagUrl = data.obj.noticeUrl;
          deMoney = data.obj.deposit/100;
          that.deposit = that.toMoney(deMoney.toString())
          that.shareInit()
        })
    },
    checkClick(){
      let that = this;
      that.checkNum++;
      console.log(that.checkNum)
      console.log(that.checkState)
      // that.checkFlag = true
    },
    checkFlagClick(){
      let that = this;
      that.checkFlag = false
      that.checkState = true
    },
    showCheckImg(){
      let that = this;
      that.checkFlag = true
    },
    getHouse() {
      let that = this;
      Indicator.open({
        text: "房源详情加载中...",
        spinnerType: "fading-circle"
      });
      console.log(that.houseCode);
      request
        .get(that.global.API_URL, {
          action: "/hf/OrderAction/getHouseInfo",
          requestParam: {
            houseCode: that.houseCode
          }
        })
        .then(function(data) {
          console.log(JSON.parse(data.obj));
          Indicator.close();
          that.houseData = JSON.parse(data.obj).houseResource;
          that.buildingData = JSON.parse(data.obj).building;
          console.log(that.buildingData)
          // if (
          //   JSON.parse(data.obj).building.isShowUnit &&
          //   JSON.parse(data.obj).building.isShowUnit == 1
          // ) {
          //   that.hasUnitFlag = true;
          //   that.postHouseInfo = that.buildingData.periodName + that.houseData.buildingName + that.houseData.unit + that.houseData.name
          // } else {
          //   that.hasUnitFlag = false;
            that.postHouseInfo = that.buildingData.periodName + that.houseData.buildingName+ that.houseData.unit + that.houseData.saleFloorRoomName 
          // }
          that.prizeAll = that.toMoney(that.houseData.houseSumFacePrice);
          console.log(that.postHouseInfo)
        });
    },
    // 给销售员打电话
    callSalePhone() {
      let that = this;
      location.href = `tel:${that.saleMobile}`;
    },
    // 财务数据转化
    toMoney(num) {
      if (num) {
        var newNum = num.replace("元", "");
        newNum = typeof newNum == "string" ? parseFloat(newNum) : newNum; //判断是否是字符串如果是字符串转成数字
        newNum = newNum.toFixed(2); //保留两位
        newNum = parseFloat(newNum); //转成数字
        newNum = newNum.toLocaleString(); //转成金额显示模式
        //判断是否有小数
        if (newNum.indexOf(".") == -1) {
          newNum = "￥" + newNum + ".00";
        } else {
          newNum =
            newNum.split(".")[1].length < 2
              ? "￥" + newNum + "0"
              : "￥" + newNum;
        }
        return newNum; //返回的是字符串23,245.12保留2位小数
      } else {
        return (num = null);
      }
    },
    shareInit(){
      let that = this;
      //设置分享
      that.global.SHARE_TITLE = `${that.shareProjectName}售楼中心，线上看房，实时咨询，欢迎您的光临！`;
      that.global.SHARE_DESC = `美好人居，一触即达。帮忙传播，更有多重惊喜哟！`;
      that.global.SHARE_IMG_URL =
        "http://assets.rurushishi.com/yq-rs-make/huafasubscription/hfrgShare.jpg";
      let shareLink = `${location.protocol}//${location.host}/h5/huafasubscription/housePage?pid=${this.projectid}&refereeopenid=${
        this.shareSpreadInfo.refereeopenid
      }`;
      console.log(shareLink)
      that.global.SHARE_LINK = shareLink;
      wxsdk.init();
    }
  },
  mounted() {
    let that = this;
    that.getConfig();
    that.getHouse();
    that.getUserInfo();
    comreq.getUserInfo().then(function(userInfo) {
      console.log(userInfo);
    });
  }
};
</script>
<style lang="stylus" scoped>
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.wrapper {
  background-color: #FFFFFF;
  font-family:PingFang SC
}
.topBox{
  width 100%
  height 1.96rem
  background url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/ttop4.png') no-repeat center
  background-size 6.7rem .84rem
  border-bottom .2rem solid #FAFAFA
}
.houseTitle{
  height 2.34rem
  line-height 2.34rem
  width 100%
  text-align center
  font-size .38rem
  font-weight bold
  border-bottom 1px solid #F2F2F2
}
.prizeBox{
  height 1.3rem
  line-height 1.3rem
  font-size .32rem
  padding-left .3rem
  box-sizing border-box
  margin-bottom .3rem
}
.ps1{
  color #333333
  margin-right .45rem
}
.ps2{
  color #E6002D
}
.hBox1,.sBox1{
  margin-top .3rem
}
.bp1{
  margin-bottom .3rem
}
.houseBox{
  line-height .54rem
  padding-left .3rem
  box-sizing border-box
}
.hs1{
  display inline-block
  width 1.5rem
}
.saleBox{
  line-height .54rem
  padding-left .3rem
  box-sizing border-box
}
.ss1{
  display inline-block
  width 2rem
}
.wranTitle {
  display flex
  width 7rem
  margin 0 auto
  margin-top 0.65rem
  line-height 31px
  height 31px
}

.line {
  height 2px
  background #BABBBD
  flex 1
  margin-top 15px
}

.wran {
  color #999999
  flex 1
  text-align center
}

.wranText {
  width 6rem
  margin 0.2rem auto
  text-align center
  color #999999
  font-size 0.24rem
  line-height 0.4rem
}
.sureBtn {
  width 6.9rem
  height 0.9rem
  margin 0 auto
  margin-top .4rem
  margin-bottom .4rem
  text-align center
  line-height 0.9rem
  color white
  font-size 0.3rem
  background #E6002D
  border-radius 5px
}
.callBox{
  width 100%
  height 100%
  position fixed
  left 0
  top 0
  background white
}
.yesImg{
  width 1.16rem
  height 1.16rem
  background url('http://assets.rurushishi.com/yq-rs-make/huafasubscription/yes.png') no-repeat center
  background-size 100% 100%
  margin 1.6rem auto .44rem
}
.yesText{
  width 100%
  font-size .38rem
  color #5DAE72
  line-height .53rem
  text-align center
  margin-bottom .58rem
}
.showText{
  width 5.5rem
  color #333333
  line-height .38rem
  margin 0 auto
  margin-bottom .58rem
}
.saleInfo{
  width 6.26rem
  padding .33rem
  box-sizing border-box
  border 1px solid #5DAE72
  border-radius 10px
  margin 0 auto
}
.saleInfoBox img{
  width .68rem
  height .68rem
  border-radius 50%
  margin-right .1rem
}
.callSale{
  width 5.5rem
  height .88rem
  line-height .88rem
  background url('http://assets.rurushishi.com/yq-rs-make/huafasubscription/call.png') no-repeat .7rem center #1959A7
  background-size .32rem .32rem
  border-radius 10px
  margin-top .33rem
  color white
  text-indent 1.5rem
}
.readCheck{
  width 100%
  height 1rem
  line-height 1rem
  margin 0 auto
  padding-left .3rem
  box-sizing border-box
}
input[type='checkbox']{
  width 20px
  height 20px
  background-color #fff
  -webkit-appearance none
  border 1px solid #BFBFBF
  border-radius 2px
  outline none
  margin-right .3rem
}
.readCheck i{
  color #1F9DFF
  display inline-block
}
.checkBox input[type=checkbox]:checked{
  background: url("http://assets.rurushishi.com/activies/zxrcKeppel/ok.png")no-repeat center;
}
.noticeBox,.checkFlagBox{
  position fixed
  width 100%
  height 100%
  background white
  z-index 999
  left 0
  top 0
  overflow scroll
}
.noticeBox img,.checkFlagBox img{
  width 100%
  display block
}
.checkFlagBox p{
  width 2.5rem
  height .8rem
  background #E6002D
  color white
  position fixed
  bottom .2rem
  left 2.5rem
  text-align center
  line-height .8rem
  border-radius 8px
}
</style>
